import { axios } from './config';

// 首页顶部的4个标签数据
export function getTitle4(params) {
  return axios.get('/application/getCountByMonth', params, true)
}

// 企业安全风险分区管理系统（首页扇形图）
export function getFanChart(params) {
  return axios.get('/application/getResultCount', params, true)
}

// 隐患待排查柱状图
export function getDhpcData(params) {
  return axios.get('/application/troubleshootTask', params, true)
}

// 安全作业柱状图
export function getAqzyData(params) {
  return axios.get('/application/safeTask', params, true)
}

// 带巡检列表
export function getDxjList(params) {
  return axios.get('/application/firstPageInspectionRecord', params, true);
}

// 待排查表
export function getDpcList(params) {
  return axios.get('/application/firstPageTroubleshootTask', params, true);
}

// 待考试表
export function getDksList(params) {
  return axios.get('/application/firstPagQuestionnaire', params, true);
}

// 新增值班获取人员下拉框的数据
export function getPeopleList(params) {
  return axios.get('/businessManagement/userManagement/getAllUser', params, true)
}

// 值班新增接口
export function addJrzbData(params) {
  return axios.post('/onDuty/save', params, true)
}

// 值班查询列表接口（首页表格也是用这个 首页要传一个时间戳）
export function getJrzbList(params) {
  return axios.post('/onDuty/list_all', params, false)
}

// 值班查询列表删除
export function removeJrzbData(params) {
  return axios.post(`/onDuty/delete/${params}`, true)
}

// 值班编辑接口
export function edithJrzbData(params) {
  return axios.post('/onDuty/update', params, true)
}

// 首页重大危险源预警系统
export function getZdyjData(params) {
  return axios.get('/application/warningStatistical', params, true)
}

// 运行报警的数据
// export function getYxbjData(params) {
//   return axios.post('/channelrecord/list_all', params, false)
// }
export function getYxbjData(params) {
  return axios.post('/alertData/alert_list', params, true)
}

// 快速链接列表
export function getKsjrList(params) {
  return axios.get('/quickLinks/list_all', params, false)
}

// 快速链接 保存
export function saveKslj(params) {
  return axios.post('/quickLinks/save', params, true)
}

// 快速链接 删除
export function deleteKslj(params) {
  return axios.post(`/quickLinks/delete/${params}`, true)
}

// 快速链接  编辑
export function editKslj(params) {
  return axios.post('/quickLinks/update', params, true)
}

// 到期提醒
export function getDqtx(params) {
  return axios.post('/expirationReminder/getExpirationReminder', params, true)
}

// 取消提醒
export function cancelDqtx(params) {
  return axios.post('/expirationReminder/update', params, true)
}

// /processtemplate/page  流程模板
export function processtemplatePage(params) {
  return axios.get('/processtemplate/page', params, false)
}
